import { render, staticRenderFns } from "./VehicleAssignToBuyerAction.vue?vue&type=template&id=487d2268&scoped=true"
import script from "./VehicleAssignToBuyerAction.vue?vue&type=script&lang=js"
export * from "./VehicleAssignToBuyerAction.vue?vue&type=script&lang=js"
import style0 from "./VehicleAssignToBuyerAction.vue?vue&type=style&index=0&id=487d2268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d2268",
  null
  
)

export default component.exports